import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Link } from "react-router-dom";
import Select from "react-select";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const FontList = (props) => {
  const [characters, updateCharacters] = useState([]);
  const [itemid, setItemId] = useState("");
  const [newItem, setnewItem] = useState("");
  const fileName = useFormInput("");

  const menuPic = [
    {
      value: "First Section",
      label: "First Section",
    },
    {
      value: "Second Section",
      label: "Second Section",
    },
    {
      value: "Third Section",
      label: "Third Section",
    },
  ];

  /* eslint-disable no-unused-vars */
  const [allIcon, setIcon] = useState(menuPic);
  const [hold] = useState(props.dir);
  const [fileList, setFileList] = useState([]);
  /* eslint-disable no-unused-vars */
  /* const newContainer = (event)=>{
      event.preventDefault();
      const newer ={
        "value":"unnamedItem",
        "label":"unamedItem",
        "order":characters.length+1,
        "id":characters.length+1
      }
      updateCharacters([...characters, newer]);
      
    } */

  const checkValueExist = (value) => {
    return characters.some(function (el) {
      return el.value === value;
    });
  };

  const onChangeItem = (value) => {
    setItemId(value.value);
    setnewItem(value);
  };

  const newContainer = (event) => {
    event.preventDefault();

    const newer = {
      value: itemid,
      label: fileName.value,
      order: characters.length + 1,
      file: itemid,
      id: itemid,
      fontType: "Custom Font",
    };

    if (characters.length < 2 && !checkValueExist(newer.value)) {
      updateCharacters([...characters, newer]);
      const newArray = [...characters, newer];
      props.onChange(newArray);
    } else {
      toastr.error("Limit Reached or item Already Exist", "Error");
    }
  };

  useEffect(() => {
    setFileList([...props.data]);
    const getDetails = () => {
      const opt = props.listData.map((item) => ({
        value: item.itemid,
        label: item.itemRef,
        order: item.itemOrder,
        id: item.itemid,
        file: item.itemFile,
        fontType: item.itemFontType,
      }));

      updateCharacters(opt);
    };

    getDetails();
  }, [props.data, props.listData]);
  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;
    props.onChange(newArr);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);
    reorderArray(items);
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  return (
    <div className="row mb-2 mt-2">
      {!(hold === "rtl") && (
        <>
          <div className="col-sm-12">
            <div className="form-group">
              <div className="row">
                <div className="col-md-5">
                  <label>Select File</label>
                  <Select
                    name="fileList"
                    className="form-control inside-select"
                    options={fileList}
                    onChange={onChangeItem}
                    value={newItem}
                    isDisabled={props.name === "Custom Font" ? false : true}
                  ></Select>
                </div>
                <div className="col-md-5">
                  <label>Font Name</label>
                  <input
                    type="text"
                    name="fontName"
                    className="form-control inside-form"
                    placeholder="FontName ..."
                    {...fileName}
                    autoComplete="off"
                    disabled={props.name === "Custom Font" ? false : true}
                  />
                </div>

                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-light btn-block"
                    style={{ width: "100px", marginTop: "8px", height: "40px" }}
                    onClick={newContainer}
                    disabled={
                      props.name === "Custom Font"
                        ? !fileName.value
                          ? true
                          : !newItem
                            ? true
                            : false
                        : true
                    }
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId={"characters"}>
                {(provided) => (
                  <ul
                    className="products-list product-list-in-card pl-2 pr-2"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{ maxHeight: "350px", overflowY: "scroll" }}
                  >
                    {characters.map((item, index) => (
                      <Draggable
                        key={item.id + item.order}
                        draggableId={"item" + item.id}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            className="item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className="product-info">
                              <Link
                                to={"/item/" + item.value + "/" + item.id}
                                className="product-title"
                              >
                                {item.label}
                                <span className="badge badge-warning float-left">
                                  {item.order}
                                </span>
                              </Link>
                              <div
                                className="text-right"
                                style={{ display: "inline", float: "right" }}
                              >
                                <Link
                                  className="btn btn-light btn-sm"
                                  to="#!"
                                  onClick={(event) =>
                                    handleRemove(event, index)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </Link>
                              </div>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </>
      )}

      {hold === "rtl" && (
        <>
          <div className="col-sm-12">
            <div className="form-group">
              <div className="row">
                <div className="col-md-2">
                  <button
                    type="button"
                    className="btn btn-light btn-block"
                    style={{ width: "100px", marginTop: "8px", height: "40px" }}
                    onClick={newContainer}
                    disabled={
                      props.name === "Custom Font"
                        ? !fileName.value
                          ? true
                          : !newItem
                            ? true
                            : false
                        : true
                    }
                  >
                    Add
                  </button>
                </div>
                <div className="col-md-5" dir={props.dir}>
                  <label
                    className={
                      props.dir === "rtl" ? "float-right" : "float-left"
                    }
                  >
                    Select File
                  </label>
                  <Select
                    name="fileList"
                    className="form-control inside-select float-right"
                    options={fileList}
                    onChange={onChangeItem}
                    value={newItem}
                    isDisabled={props.name === "Custom Font" ? false : true}
                  ></Select>
                </div>
                <div className="col-md-5">
                  <label
                    className={
                      props.dir === "rtl" ? "float-right" : "float-left"
                    }
                  >
                    Font Name
                  </label>
                  <input
                    type="text"
                    name="fontName"
                    className="form-control inside-form float-right"
                    placeholder="FontName ..."
                    {...fileName}
                    dir={props.dir}
                    autoComplete="off"
                    disabled={props.name === "Custom Font" ? false : true}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId={"characters"}>
                {(provided) => (
                  <ul
                    className="products-list product-list-in-card pl-2 pr-2"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{ maxHeight: "350px", overflowY: "scroll" }}
                  >
                    {characters.map((item, index) => (
                      <Draggable
                        key={item.id + item.order}
                        draggableId={"item" + item.id}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            className="item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div className="product-info">
                              <Link
                                to={"/item/" + item.value + "/" + item.id}
                                className="product-title"
                              >
                                {item.label}
                                <span className="badge badge-warning float-left">
                                  {item.order}
                                </span>
                              </Link>
                              <div
                                className="text-right"
                                style={{ display: "inline", float: "right" }}
                              >
                                <Link
                                  className="btn btn-light btn-sm"
                                  to="#!"
                                  onClick={(event) =>
                                    handleRemove(event, index)
                                  }
                                >
                                  <i className="fas fa-trash"></i>
                                </Link>
                              </div>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </>
      )}
    </div>
  );
};

const useFormInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return {
    value,
    onChange: handleChange,
  };
};
export default FontList;
